import * as Yup from 'yup';
import { isValidCpf } from '../utils/isValidCpf';

export const partnerRules = {
    partnerName: Yup.string().required('Nome do sócio é obrigatório'),
    partnerDocument: Yup.string()
        .required('Campo obrigatório')
        .test('invalid', 'CPF inválido', (value) => isValidCpf((value || '').replace(/\D/g, ''))),
    partnerBirthDate: Yup.string().required('Data de nascimento é obrigatório'),
    partnerEmail: Yup.string()
        .required('Email é obrigatório')
        .email('E-mail inválido'),
    partnerPhone: Yup.string().required('Telefone é obrigatório'),
};

export default partnerRules;
